import { TranslateService } from '@ngx-translate/core';
import { LayoutNavigation } from '../components';

/**
 * Conditionally set the screen reader text for the logo link in the upper left corner of the nav bar
 * @param translate The Translate Service
 * @param windowRef The Window object
 * @param navigation The navigation object for our layout configuration
 * @returns
 */
export const screenReaderTextForLogo = (
  translate: TranslateService,
  windowRef: Window,
  navigation: LayoutNavigation
): string => {
  let screenReaderText;
  const isOrgView = windowRef.location.pathname.indexOf('orgs') !== -1;
  const isOnboardingPage =
    windowRef.location.pathname.indexOf('getstarted/welcome') !== -1;
  if (isOrgView) {
    screenReaderText = firstVisibleAdminNavSection(navigation);
  } else if (isOnboardingPage) {
    screenReaderText = translate.instant('Onboarding_SectionTitle');
  } else {
    screenReaderText = translate.instant('Core_Home');
  }
  return screenReaderText;
};

const firstVisibleAdminNavSection = (navigation: LayoutNavigation): string => {
  const visibleNavItems = navigation.top.filter((navItem) => navItem.visible);
  return visibleNavItems[0]?.text || '';
};
